// extracted by mini-css-extract-plugin
export default {"appContainer":"app-container__M7BMNkPh"};